const CHOICES_ALL_HANDS = [
  "Dedication",
  "Hit the ground running",
  "Efficiency",
  "We lost a major customer",
  "Layoffs mentioned directly",
  "Uh...\nUmmm\nUhhh",
  "Streamline",
  "Exciting times",
  "Attempt to raise morale",
  "Solutions",
  "Company is doing great",
  "Speaker obviously didn't write what they are reading",
  "Euphemism used for layoffs",
  "Waiting for people",
  "Innovate",
  "to trickle in",
  "Core Competency",
  "Development gets talked about for 2 mins or less",
  "Customer Centricity",
  "Expecting the same output from employees despite the layoffs",
  "Human Capital",
  "Raises mentioned",
  "Customers not happy",
  "C Suite Turnover",
  "Bragging about a customer gained",
];

const CHOICES_SEINFELD = [
  "Kramer opens the door",
  "Meet Jerry's Girlfriend",
  "Hello Newman",
  "Elaine pushes",
  "Jerry appears",
  "George appears",
  "Elaine appears",
  "Kramer appears",
  "Someone drinking coffee",
  "Riding in a car",
  "In laundromat, store, or gym",
  "In office or business",
  "Walking Bass Line",
  "Jerry smirking out of character"
];

/**
 * Map of values from `TileOptions` to the array of tiles
 */
export const TileSetMap = {
  "all-hands": CHOICES_ALL_HANDS,
  "seinfeld": CHOICES_SEINFELD
};

/**
 * Array of options to include as a preset
 */
export const TileOptions = [
  { value: "all-hands", display: "All Hands" },
  { value: "seinfeld", display: "Seinfeld" },
];
